
import { REQUEST_TYPE } from "./network/net";
import Stream from "./frp/stream";
import { in_iframe } from 'utils'

export default function(
    leaf,
    space,
    serverOptions,
    lobbyURL,
)
{
    const ed = space.child( 'error_driver' )
    
    space.s( 'error' ).subscribe( e => console.error( "Network error:", e ) );
    
    function call_leaf( method ) {
        if ( leaf.obj && leaf.obj[ method ] ) leaf.obj[ method ]()
    }
    
    //fatal:
    const $fatal = space.s( 'error' ).filter( ({ type }) => type == "fatal" )
    $fatal.subscribe( fatal => {
        if ( fatal.redirectUrl ) setTimeout( () => call_leaf( 'showFatalErrorBanner' ), 5000 )
        else call_leaf( 'showFatalErrorBanner' )
    } )
    //is error:
    const $isError = ed.s( "isError" );
    space.s( 'error' )
        .filter( ({ type }) => type == "fail" )
        .map( () => true )
        .merge( $fatal.map( () => true ) )
        .merge( space.s( 'net' ).map( () => false ) )
        .subscribe( $isError );
    //fail:
    $isError
        .distinctUntilChanged()
        .with( $fatal, ( show, fatal ) => ({ show, postpone : fatal && fatal.redirectUrl }) )
        .subscribe( ({ show, postpone }) => {
            if ( show ) {
                if ( postpone ) setTimeout( () => call_leaf( 'showNoConnectionBanner' ), 5000 )
                else call_leaf( 'showNoConnectionBanner' )
            }
            else call_leaf( 'hideErrorBanners' )
        } )
    //reconnections:
    let reconnectTimeout = undefined;
    $isError
        .filter( isError => isError )
        .subscribe( fail =>
        {
            if ( reconnectTimeout )
            {
                clearTimeout( reconnectTimeout );
                reconnectTimeout = undefined;
            }
            
            if ( fail )
            {
                reconnectTimeout = setTimeout(
                    () =>
                    {
                        reconnectTimeout = undefined;
                        
                        space.s( 'request' ).next( {
                            type : REQUEST_TYPE.INIT,
                            options : serverOptions
                        } )
                    },
                    4100
                );
            }
        } );
    
    $fatal.subscribe( fatal => {
        console.error( 'Fatal error: redirecting to', fatal.redirectUrl, ' or ', lobbyURL, ' ...' )
        if ( fatal.redirectUrl && fatal.redirectUrl != 'undefined' )
        {
            window.location.replace( fatal.redirectUrl )
            //not sure, but maybe when internet is completely disconnected redirection doesn't work:
            setInterval( () => window.location.replace( fatal.redirectUrl ), 5000 )
            return;
        }
        if ( fatal.instant ) goLobby( lobbyURL )
        else setTimeout( () => goLobby( lobbyURL ), 5000 )
    } );
    
    //preloader:
    const $preloader = ed.s( "progress_indicator" );
    let timeout = undefined;
    //start countdown:
    space.s( 'pending' )
        .filter( pending => pending )
        .subscribe( () =>
        {
            //as I understand, it may happen because of orderless events propagation - spin->request may turn out to be just "spin":
            //how?:
            if ( timeout )
            {
                //console.error( "HOW!?" );
                return;
            }
            
            timeout = setTimeout( () =>
            {
                timeout = undefined;
                $preloader.next( true );
            }, 3000 );
        } );
    //cancel countdown or hide it:
    space.s( 'net' )
        .merge( $isError.filter( isError => isError ) )
        .subscribe( () =>
        {
            if ( timeout ) clearTimeout( timeout );
            timeout = undefined;
            $preloader.next( false );
        } );
    const $preloader_also_visible = ed.s( 'preloader_also_visible' )
    $preloader
        .any( $preloader_also_visible, ( p, v ) => p || v )
        .on( show => show ? call_leaf( 'showProcessIndicator' ) : call_leaf( 'hideProcessIndicator' ) )
    
    const $goLobby = ed.s( "goLobby" );
    $goLobby.on( () => goLobby( lobbyURL ) );
    
    return {
        $isError,
        $goLobby,
        $preloader,
        $preloader_also_visible,
        $fatal,
    };
}

//TODO: can determine if lobby is present with this way:
//run.ui.ui.havingLobby = server.lobbyURL && server.lobbyURL.length > 0 ? true : false;
function goLobby( lobbyURL )
{
    //теперь игры хостятся в iframe и надо сообщить родительскому контейнеру что игра хочет перейти в лобби (по ошибке или по желанию игрока):
    if ( in_iframe() )
    {
        console.log( 'sending', 'game_close', 'message to iframe host ...' )
        window.top.postMessage( "game_close", "*" );
    }
    //пусть старый код работает если игра хостится по-старому (например в разработческом лобби):
    else
    {
        //for now game is hosted throughout multiple lobby pages and so we do not assume any default lobby anymore:
        if ( ! lobbyURL ) return;
        console.log( 'redirecting to', lobbyURL, '...' )
        window.location.replace( lobbyURL );
    }
};




// WEBPACK FOOTER //
// ./src/library/error.es6